(function () {
  document
    .querySelector('#headerShareLinks .line')
    .addEventListener('click', lineLink);
  document
    .querySelector('#headerShareLinks .plurk')
    .addEventListener('click', sharePlurk);
  document
    .querySelector('#headerShareLinks .fb')
    .addEventListener('click', shareFb);
  document
    .querySelector('#headerShareLinks .twitter')
    .addEventListener('click', shareTwitter);

  function shareFb() {
    var $url = encodeURIComponent(location.href);
    window.open('https://www.facebook.com/share.php?u=' + $url);
  }
  function lineLink() {
    var $url = encodeURIComponent(location.href);
    if (window.innerWidth <= 1024) {
      window.open(
        'line://msg/text/' + $url,
        '_blank',
        'toolbar=yes,location=yes,directories=no,status=no, menubar=yes,scrollbars=yes,resizable=no, copyhistory=yes,width=503,height=510'
      );
    } else {
      window.open(
        'https://lineit.line.me/share/ui?url=' + $url + '?1',
        null,
        'width=503,height=510,resizable=yes,scrollbars=no,chrome=yes,centerscreen=yes'
      );
    }
  }
  function sharePlurk() {
    var $url = encodeURIComponent(location.href);
    window.open('https://plurk.com/?qualifier=shares&status=' + $url);
  }
  function shareTwitter() {
    var $url = encodeURIComponent(location.href);
    window.open('https://twitter.com/share?url=' + $url);
  }
})();
